export default __webpack_public_path__ + "static/media/mintd360-active.33447350.svg";